export default {
    // ForecastDate
    forecastDate: 'ForecastDate',
    // Mode
    mode: 'Mode',
    // LayerType
    linearFillColor:'GradFill',
    mask:'Mask',
    gridData:'GridData',
    seaLevelPressure:'Pressure',
    flowLine:'FlowLine',
    gridWind:'WindGrid',
    // GPH
    GPH:'GPH',
    undefined:'UNDEF',
    // WIUV
    WIUV:'WIUV',
    wind:'',
    // DateInterval and ForecastTime
    dateInterval: 'DateInterval',
    forecastTime: 'ForecastTime',

    // Menu
    situationField: 'SituationField',

    averageWindSpeed: 'AVEWindSpeed',
    hourlyAverageWindSpeed: 'L_WIUV',
    maxAverageWindSpeed12H:'L_WS12',
    maxAverageWindSpeed24H:'L_WS24',
    processMaxAverageWindSpeed:'L_WSP',

    average10mWindSpeed: 'AVE10mWindSpeed',
    hourlyAverage10mWindSpeed: 'UV',
    maxAverage10mWindSpeed12H:'WS12',
    maxAverage10mWindSpeed24H:'WS24',
    processMaxAverage10mWindSpeed:'WSP',


    gust10mWindSpeed: 'Gust10mWindSpeed',
    hourlyGust10mWindSpeed: 'GUST',
    extremeGust10mWindSpeed12H:'GS12',
    extremeGust10mWindSpeed24H:'GS24',
    processExtremeGust10mWindSpeed:'GSP',

    pressure24hChange:'Pressure24hChange',
    temperature24hChange:'TMP24hChange',

    precipitation: 'Precipitation',

    accumulated: 'TPRE',
    
    convectivePrecipitation: 'CPPrecipitation',

    largeScalePrecipitation: 'LPPrecipitation',

    specificHumidity: 'SpecificHumidity',
    relativeHumidity: 'RelativeHumidity',
    hourlyRelativeHumidity: 'RH',
    maxRelativeHumidity: 'RHA',
    minRelativeHumidity: 'RHI',
    specificHumidity2m: 'SHU',
    dewPoint2m: 'DPT',
    precipitableWater: 'PWAT',
    divergence: 'L_DIV',

    verticalWindShear: 'VerticalWindShear',

    pseudoEquivalentPotentialTemperature: 'L_PPT',
    CAPE: 'CAPE',
    KIndex: 'KIndex',
    LCL: 'LCL',

    moistureFlux:'L_MOFU',
    moistureFluxDivergence:'L_MFVO',
    landSeaTemperatureDifference: 'T_TSS',
    CIN: 'CIN',
    
    temperature: 'Temperature',

    temperature2m: 'Temperature2m',
    hourlyTemperature2m: 'TEM',
    dailyMaxTemperature2m: 'TMAX',
    dailyMinTemperature2m: 'TMIN',

    dewPointTemperature2m: 'DPTemperature2m',
    hourlyDewPointTemperature2m: 'DPT',
    dailyMaxDewPointTemperature2m: 'DPTMAX',
    dailyMinDewPointTemperature2m: 'DPTMIN',

    pressureChange24H: 'SC24H',
    temperatureChange24H: 'TC24H',
    temperatureAdvection: 'L_TEAD',

    highCloudCover: 'HighCloudCover',
    hourlyHighCloudCover: 'HCC',
    maxHighCloudCover24H: 'HCA',

    mediumCloudCover: 'MedCloudCover',
    hourlyMediumCloudCover: 'MCC',
    maxMediumCloudCover24H: 'MCA',

    lowCloudCover: 'LowCloudCover',
    hourlyLowCloudCover: 'LCC',
    maxLowCloudCover24H: 'LCA',

    totalCloudCover: 'TotalCloudCover',
    hourlyTotalCloudCover: 'TCC',
    maxTotalCloudCover24H: 'TCA',

    visibility: 'Visibility',
    hourlyVisibility: 'VIS',
    minVisibility: 'VMIN',

    seaSurfaceTemperature: 'SeaSurfaceTmp',

    severeConvection: 'SevereConvection',
    compositeReflectivity: 'CR',

    shadow: 'Shadow',
    isoline: 'Isoline',
    geopotentialHeightIsoline: 'GPH Isoline',
    seaLevelPressureIsoline: 'SLP Isoline',

    currentModeNotAvailable: 'Current mode does not support ',

    longitude: 'Lon',
    latitude: 'Lat'
  };
  
  export const enMessages = {
    "situationField": "SituationField",
    "precipitation": "Precipitation",
    "temperature": "Temperature",
    "visibility": "Visibility",
    "severeConvection": "SevereConvection",
  }